import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async (params) => {
  return await axiosIns.get(obtenerUrl('solicitudes'), { params });
};

const getAll = async (params) => {
  return await axiosIns.get(obtenerUrl('solicitudes'), { params });
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('solicitudes'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`solicitudes/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`solicitudes/${id}`));
};

const show = async (id) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/${id}/detalle`));
};

const revisar = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`solicitudes/${id}/revisar`), data);
};

const desembolsar = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`solicitudes/${id}/desembolsar`), data);
};

const getPartida = async (sede_origen_id, clasificador) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/${sede_origen_id}/partida?clasificador=${clasificador}`));
};

const getNacPartida = async (sede_origen_id, clasificador) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/${sede_origen_id}/nacional-partida?clasificador=${clasificador}`));
};

const reporte = async (id) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/${id}/reporte`), { responseType: 'arraybuffer' });
};

const reporteTodos = async (params) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/reporte`), {
    params,
    responseType: 'arraybuffer',
  });
};

const reporteTodosConsolidado = async (params) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/reporte-consolidado`), { params });
};

const reporteTodosConsolidadoSubtotales = async (params) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/reporte-consolidado-subtotales`), {
    params,
    responseType: 'arraybuffer',
  });
};

const reporteTodosConsolidadoPorCuentaOrigen = async (params) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/reporte-consolidado-por-cuenta-origen`), {
    params,
    responseType: 'arraybuffer',
  });
};

const storeImporteDetalleSolicitudRechazado = async (data) => {
  return await axiosIns.post(obtenerUrl(`solicitudes/importe-detalle-solicitud-rechazado`), data);
};

const storeCambiarCuentasDetalleSolicitud = async (datos) => {
  return await axiosIns.post(obtenerUrl(`solicitudes/cambio-cuentas-detalle-solicitud`), datos);
};

export default {
  get,
  store,
  update,
  destroy,
  show,
  revisar,
  desembolsar,
  getAll,
  getPartida,
  getNacPartida,
  reporte,
  reporteTodos,
  reporteTodosConsolidado,
  reporteTodosConsolidadoSubtotales,
  reporteTodosConsolidadoPorCuentaOrigen,
  storeImporteDetalleSolicitudRechazado,
  storeCambiarCuentasDetalleSolicitud,
};
